import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { makeMentionsSelector } from "../../redux/selectors/mentions";

const minOpenEndLengthKey = "MinOpenEndLength";
const errorKey = "InvalidCharactersMin";

export default function openEndMinimumLength(variable) {
    const { name: variableName, choiceList } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());

        const [minimumViolation] = mentions
            .map((mention) => {
                const { openEnd = "" } = mention;
                const { settings = {} } = choiceList.find(
                    (choice) => choice.value === mention.value,
                );
                const minimum = settings[minOpenEndLengthKey];
                return {
                    openEnd: openEnd.trim(),
                    minimum,
                };
            })
            .filter(({ openEnd, minimum }) => openEnd.length && minimum !== undefined)
            .map(({ openEnd, minimum }) => (openEnd.length < minimum ? minimum : undefined))
            .filter((minimum) => minimum !== undefined);

        if (minimumViolation) {
            return {
                variableName,
                error: { key: errorKey, args: { min: minimumViolation } },
            };
        }

        return null;
    };
}
